export const MODULE_NAME = 'user';
